module.exports = __webpack_public_path__ + "img/D8C949_F5F19E_6B7855_9A9858-256px.dbae2bd1.png";